import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants/networking.constants';
import { useUiStore } from '@/store/ui';
import { AlertSeverityEnum, PlanesCorporativos, PlanesCorporativosForm, PlanesCorporativosParams, PlanesCorporativosResp, UseMutationsParams } from '@/shared/interfaces';

const { get, post, put } = erpApi();

///* Obtener capacidades corporativos

export const useGetPlanCorporativo = (params: PlanesCorporativosParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['plancorporativo', ...Object.values(params || {})],
    queryFn: async () => {
      return await getPlanCorporativo(params);
    },
    retry: false,
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const getPlanCorporativo = async (params?: PlanesCorporativosParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<PlanesCorporativosResp>(
    `${urlBackend}api/v1/plancoorporativo/?${queryParams}`,
    true
  );
  return resp;
};


///* Obtener capcaidad corporativo por uid
export const useGetPlanCorporativoById = (id: string) => {
  return useQuery({
    queryKey: ['plancorporativo'],
    queryFn: async () => {
      return getPlanCorporativoById(id);
    },
    refetchOnWindowFocus: false
  });
};

export const getPlanCorporativoById = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<PlanesCorporativos>(`${urlBackend}api/v1/plancoorporativo/${id}`, true);
  res.status === 'error' && setAlert(true, res.message, 'error');

  return res.data;
};

///* Crear capacidad corporativa
export const usePostPlanCorporativo = ({
  navigate,
  returnUrl

}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({

    mutationFn: postPlanCorporativo,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['plancorporativo'] });

      if (data.code == 200)
        navigate && returnUrl && navigate(returnUrl)

      setAlert(true, data.message, data.status);
    },

    onError: (e => {
      setIsGlobalLoading(false);
      handleAxiosError(e);
    }),
  });
};

export const postPlanCorporativo = async (data: PlanesCorporativosForm) => {
  const res = await post<PlanesCorporativos>(`${urlBackend}api/v1/plancoorporativo/`, data, true);
  return res;
};



export const usePutPlanCorporativo = ({
  enableAlert = true,
  navigate,
  returnUrl
}: UseMutationsParams) => {

  const setAlert = useUiStore.getState().setAlert;

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: Partial<PlanesCorporativos>;
    }) => {
      return putPlanCorporativo({ data: data, id: id });
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['plancorporativo'] });

      if (data.code == 200)
        navigate && returnUrl && navigate(returnUrl)

      enableAlert && setAlert(true, data.message, AlertSeverityEnum.success)
    },
    onError: (error) => {
      handleAxiosError(error);
    }
  });
};

export const putPlanCorporativo = async (
  { id, data }: {
    id: string,
    data: Partial<PlanesCorporativos>
  }
) => {
  const res = await put<PlanesCorporativos>(`${urlBackend}api/v1/plancoorporativo/${id}/`, data, true);
  return res;
};
